import React from 'react';
import PropTypes from 'prop-types';
import { Container, Section } from 'components/base';
import { CloudinaryPicture, HtmlContent, getCloudinaryUrl } from 'components/rich';
import useDataContext from 'data/context/data';

import { Head, Layout } from '../../components/layout';
import { NewsletterSection, ProductsSection } from '../../components/custom/mainSections';
import HeroBanner from '../../components/custom/heroBanner';

const CategoryPage = props => {
  const dataContext = useDataContext();

  const category = dataContext.getCategory(props.categoryId);

  return (
    <React.Fragment key={category.id}>
      <Head
        title={category.seoTitle ?? category.name}
        description={category.shortDescription}
        image={props.content.seoUrl || getCloudinaryUrl({ imageKey: category.image })}
        keywords={props.content.seoKeywords}
      />

      <Layout>
        {category.banner && (
          <Section className="py-0">
            <HeroBanner title={category.name.toUpperCase()} description={category.shortDescription}>
              <CloudinaryPicture imageKey={category.image} className="w-100" />
            </HeroBanner>
          </Section>
        )}

        {category.data.map(item => (
          <ProductsSection
            key={item.key}
            title={item.title}
            subCategories={item.subCategories}
            products={item.products}
            xs={12}
            md={4}
          />
        ))}

        {props.content.extraDescription && (
          <Section>
            <Container className="my-5">
              <HtmlContent html={props.content.extraDescription} />
            </Container>
          </Section>
        )}

        <NewsletterSection />
      </Layout>
    </React.Fragment>
  );
};

CategoryPage.getInitialProps = async () => {
  throw new Error('Cannot access this page directly. See /[...params] page');
};

CategoryPage.propTypes = {
  categoryId: PropTypes.string.isRequired,
  content: PropTypes.object,
};

export default CategoryPage;
